import * as Types from '../../types.generated';

import { gql } from '@apollo/client';
import { MyTranslationSetFragmentDoc, CoverImageFragmentDoc } from '../../fragments.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type MyTrainingAssignmentsTableQueryVariables = Types.Exact<{
  input: Types.MyTodoAssignmentsInput;
  pagination?: Types.InputMaybe<Types.PaginationInput>;
}>;


export type MyTrainingAssignmentsTableQuery = { __typename?: 'Query', MyTodoAssignments: { __typename?: 'Assignments', totalCount: number, objects: Array<{ __typename?: 'Assignment', id: string, status: AssignmentStatus, attemptsCount: number, accessSources: Array<{ __typename?: 'AccessSource', id: string, createdAt: string }>, libraryItem: { __typename?: 'LibraryItem', id: string, type: Types.LibraryItemType, name: { __typename?: 'TranslationSet', uuid: string, myTranslation: string }, coverImage?: { __typename?: 'CoverImage', id: string, emojiIcon?: string | null, background?: Types.BackgroundGradient | null, imageUrls?: { __typename?: 'ImageUrls', id: string, original: string, wide?: string | null, medium?: string | null, thumb?: string | null } | null } | null, description: { __typename?: 'TranslationSet', uuid: string, myTranslation: string } }, currentCourseInstance?: { __typename?: 'CourseInstance', id: number, track?: number | null, startedAt?: string | null, completedAt?: string | null, percentComplete: number, dueDate?: string | null, certificateUrl?: string | null } | null, currentModuleInstance?: { __typename?: 'ModuleInstance', id: string, startedAt?: string | null, completedAt?: string | null, percentComplete: number, dueDate?: string | null } | null, currentSCORMCourseInstance?: { __typename?: 'SCORMCourseInstance', id: string, startedAt?: string | null, completedAt?: string | null, dueDate?: string | null } | null }> } };

export type MyTrainingAssignmentsTable_AssignmentFragment = { __typename?: 'Assignment', id: string, status: AssignmentStatus, attemptsCount: number, accessSources: Array<{ __typename?: 'AccessSource', id: string, createdAt: string }>, libraryItem: { __typename?: 'LibraryItem', id: string, type: Types.LibraryItemType, name: { __typename?: 'TranslationSet', uuid: string, myTranslation: string }, coverImage?: { __typename?: 'CoverImage', id: string, emojiIcon?: string | null, background?: Types.BackgroundGradient | null, imageUrls?: { __typename?: 'ImageUrls', id: string, original: string, wide?: string | null, medium?: string | null, thumb?: string | null } | null } | null, description: { __typename?: 'TranslationSet', uuid: string, myTranslation: string } }, currentCourseInstance?: { __typename?: 'CourseInstance', id: number, track?: number | null, startedAt?: string | null, completedAt?: string | null, percentComplete: number, dueDate?: string | null, certificateUrl?: string | null } | null, currentModuleInstance?: { __typename?: 'ModuleInstance', id: string, startedAt?: string | null, completedAt?: string | null, percentComplete: number, dueDate?: string | null } | null, currentSCORMCourseInstance?: { __typename?: 'SCORMCourseInstance', id: string, startedAt?: string | null, completedAt?: string | null, dueDate?: string | null } | null };

export type MyTrainingAssignmentsTable_LibraryItemFragment = { __typename?: 'LibraryItem', id: string, type: Types.LibraryItemType, name: { __typename?: 'TranslationSet', uuid: string, myTranslation: string }, coverImage?: { __typename?: 'CoverImage', id: string, emojiIcon?: string | null, background?: Types.BackgroundGradient | null, imageUrls?: { __typename?: 'ImageUrls', id: string, original: string, wide?: string | null, medium?: string | null, thumb?: string | null } | null } | null, description: { __typename?: 'TranslationSet', uuid: string, myTranslation: string } };

export type MyTrainingAssignmentsTable_ModuleInstanceFragment = { __typename?: 'ModuleInstance', id: string, startedAt?: string | null, completedAt?: string | null, percentComplete: number, dueDate?: string | null };

export type MyTrainingAssignmentsTable_CourseInstanceFragment = { __typename?: 'CourseInstance', id: number, track?: number | null, startedAt?: string | null, completedAt?: string | null, percentComplete: number, dueDate?: string | null, certificateUrl?: string | null };

export type MyTrainingAssignmentsTable_ScormCourseInstanceFragment = { __typename?: 'SCORMCourseInstance', id: string, startedAt?: string | null, completedAt?: string | null, dueDate?: string | null };

export const MyTrainingAssignmentsTable_LibraryItemFragmentDoc = gql`
    fragment MyTrainingAssignmentsTable_LibraryItem on LibraryItem {
  id
  type
  name {
    ...MyTranslationSet
  }
  coverImage {
    ...CoverImage
  }
  description {
    ...MyTranslationSet
  }
}
    ${MyTranslationSetFragmentDoc}
${CoverImageFragmentDoc}`;
export const MyTrainingAssignmentsTable_CourseInstanceFragmentDoc = gql`
    fragment MyTrainingAssignmentsTable_CourseInstance on CourseInstance {
  id
  track
  startedAt
  completedAt
  percentComplete
  dueDate
  certificateUrl
}
    `;
export const MyTrainingAssignmentsTable_ModuleInstanceFragmentDoc = gql`
    fragment MyTrainingAssignmentsTable_ModuleInstance on ModuleInstance {
  id
  startedAt
  completedAt
  percentComplete
  dueDate
}
    `;
export const MyTrainingAssignmentsTable_ScormCourseInstanceFragmentDoc = gql`
    fragment MyTrainingAssignmentsTable_SCORMCourseInstance on SCORMCourseInstance {
  id
  startedAt
  completedAt
  dueDate
}
    `;
export const MyTrainingAssignmentsTable_AssignmentFragmentDoc = gql`
    fragment MyTrainingAssignmentsTable_Assignment on Assignment {
  id
  status
  attemptsCount
  accessSources {
    id
    createdAt
  }
  libraryItem {
    ...MyTrainingAssignmentsTable_LibraryItem
  }
  currentCourseInstance {
    ...MyTrainingAssignmentsTable_CourseInstance
  }
  currentModuleInstance {
    ...MyTrainingAssignmentsTable_ModuleInstance
  }
  currentSCORMCourseInstance {
    ...MyTrainingAssignmentsTable_SCORMCourseInstance
  }
}
    ${MyTrainingAssignmentsTable_LibraryItemFragmentDoc}
${MyTrainingAssignmentsTable_CourseInstanceFragmentDoc}
${MyTrainingAssignmentsTable_ModuleInstanceFragmentDoc}
${MyTrainingAssignmentsTable_ScormCourseInstanceFragmentDoc}`;
export const MyTrainingAssignmentsTableDocument = gql`
    query MyTrainingAssignmentsTable($input: MyTodoAssignmentsInput!, $pagination: PaginationInput) {
  MyTodoAssignments(input: $input, pagination: $pagination) {
    totalCount
    objects {
      ...MyTrainingAssignmentsTable_Assignment
    }
  }
}
    ${MyTrainingAssignmentsTable_AssignmentFragmentDoc}`;

/**
 * __useMyTrainingAssignmentsTableQuery__
 *
 * To run a query within a React component, call `useMyTrainingAssignmentsTableQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyTrainingAssignmentsTableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyTrainingAssignmentsTableQuery({
 *   variables: {
 *      input: // value for 'input'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useMyTrainingAssignmentsTableQuery(baseOptions: Apollo.QueryHookOptions<MyTrainingAssignmentsTableQuery, MyTrainingAssignmentsTableQueryVariables> & ({ variables: MyTrainingAssignmentsTableQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyTrainingAssignmentsTableQuery, MyTrainingAssignmentsTableQueryVariables>(MyTrainingAssignmentsTableDocument, options);
      }
export function useMyTrainingAssignmentsTableLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyTrainingAssignmentsTableQuery, MyTrainingAssignmentsTableQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyTrainingAssignmentsTableQuery, MyTrainingAssignmentsTableQueryVariables>(MyTrainingAssignmentsTableDocument, options);
        }
export type MyTrainingAssignmentsTableQueryHookResult = ReturnType<typeof useMyTrainingAssignmentsTableQuery>;
export type MyTrainingAssignmentsTableLazyQueryHookResult = ReturnType<typeof useMyTrainingAssignmentsTableLazyQuery>;
export type MyTrainingAssignmentsTableQueryResult = Apollo.QueryResult<MyTrainingAssignmentsTableQuery, MyTrainingAssignmentsTableQueryVariables>;